<template>
    <div class="bgView">
		<div class="top-tabs">
			<div class="tabs-tt-bar js-tab-nav">
                <ul class="clearfix">
                    <li class="fl tabs-tt" :class="{active:tab.isAction}" v-for="(tab,index) in tabs" :key="index" @click="tabSelected(index)">
                        {{tab.title}}
                    </li>
                </ul>
			</div>
		</div>
        <!--订单列表-->
        <div v-if="orderListArray.length>0">
            <div class="order_list">
				<!-- 订单列表 -->
				<table>
					<thead>
						<tr>
							<th>订单号</th>
							<th>商品名称</th>
							<th>金额</th>
							<th>下单时间</th>
							<th>订单状态</th>
							<th>操作</th>
							<th></th>
						</tr>
					</thead>
                    <tbody v-loading.body="loading" element-loading-text="数据加载中">
                        <tr v-for="(orderModel,index) in orderListArray" :key="index">
							<td>{{orderModel.orderNum}}</td>
							<td>{{orderModel.courseName}}</td>
							<td>￥{{orderModel.payPrice}}</td>
							<td>{{orderModel.orderTime}}</td>
							<td v-if="orderModel.payStatus == 'PAY_NON'">未支付</td>
							<td v-else-if="orderModel.payStatus == 'PAY_SUCCESS'">已支付</td>
							<td div v-else>已取消</td>
							<td>

								<a href="javascript:void(0);" style="color:red;" v-if="orderModel.payStatus == 'PAY_NON'" @click="gotoPay(orderModel.subOrderId)">立即支付</a>
								<!-- <a href="javascript:void(0);" style="color:#999;" v-else-if="orderModel.payStatus == 'PAY_SUCCESS'">交易关闭</a> -->
								
								<a class="colorOrange" style="padding:0px 8px;" href="javascript:void(0)" @click="deleteOrder(orderModel)">删除</a>
							</td>
						</tr>
                    </tbody>
				</table>
            </div>
        </div>
        <div v-else class="empty">
            <img src="../../../assets/images/empty.png">
        </div>
        <div class="page">
		<!-- <div class="page-wrap" v-if="orderListArray.length > 0 && orderListArray.page == 0"> -->
			<div class="page-wrap" v-if="orderListArray.length > 0">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="10" layout="prev, pager, next,total" :total="total">
                </el-pagination>
			</div>
		</div>
    </div>
</template>
<script>
export default {
    name:'myOrder',
    data(){
        return {
            currentPage:1,
            total: 0,
            tabs:[
				{title:'全部订单',isAction:true},
				{title:'已支付',isAction:false},
				{title:'未支付',isAction:false},
				{title:'已取消',isAction:false}
			],
			orderListArray:[],
			isAction: true,
			payStatusArr:[
				'',
				'PAY_SUCCESS',
				'PAY_NON',
				'PAY_CANCLE'
			],
			payStatusIndex:0,
			loading:true
        }
    },
    created() {
		this.tabSelected(0)
    },
    methods:{
         handleSizeChange: function (pageSize){
            console.log(pageSize);
        },
        tabSelected: function(index){
			for(var i =0;i<this.tabs.length;i++){
				var tabModel = this.tabs[i]
				if(i == index){
					tabModel.isAction = true
				}else {
					tabModel.isAction = false
				}
			}
			this.payStatusIndex = index
			this.getOrderListWithPageIndex(1,this.payStatusArr[index])
        },
        // 监听当前页
        handleCurrentChange: function (currentPage){
            // console.log(currentPage,this.payStatusIndex)
            this.currentPage = currentPage
            this.getOrderListWithPageIndex(currentPage,this.payStatusArr[this.payStatusIndex])
        },
        getOrderListWithPageIndex: function(pageIndex,payStatus){
            this.loading = true
            let params = {
                userId:localStorage.userId,
                payStatus:payStatus,
                page:pageIndex,
                pageSize:10
            }
            
            this.$http.post(this.baseUrl()+'/mobile/payOrder/findOrders',       // 还可以直接把参数拼接在url后边
				this.$qs.stringify(params),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(function(res){
                    this.orderListArray = res.data.data;
                    this.total = res.data.totalNum;
                    //console.log("加载订单课程："+this.hotsCourseList.length);
                    this.loading = false
                }).catch(function (error) {
				console.log(error);
			});
        },
        deleteOrder: function(orderModel){
            // 删除订单
            this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                let params = {
                    orderNum:orderModel.orderNum,
                    userId: localStorage.userId,
                    token: localStorage.token
                    
                }
                this.$http.post(this.baseUrl()+'/mobile/payOrder/deleteByOrderNum',       // 还可以直接把参数拼接在url后边
                    this.$qs.stringify(params),{
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    }).then(function(res){
                        if(res.data.flag==1){
                            this.getOrderListWithPageIndex(this.currentPage,this.payStatusArr[this.payStatusIndex])
                        }
                    }).catch(function (error) {
                    console.log(error);
                });
                //this.requestData('/mobile/payOrder/deleteByOrderNum',{orderNum:orderModel.orderNum},1)
            }).catch(() => {    });
        },
        
        gotoPay:function(orderId){
            //去支付
            this.$router.push('/payview/'+orderId)
        },
    }
}
</script>

<style scoped>
    .bgView {
        width: 900px;
    }
    .page {
        margin:20px auto;
    }
    .tabs{
    width: 870px;
    margin-right: 27px;
    }
    .tabs-tt-bar ul{
    border-bottom:1px solid #dfdfdf;
    padding-left: 2px;
    position: relative;
    }
    .tabs-tt-bar ul .tabs-tt{
    color: #999;
    font-size: 14px;
    padding-bottom:8px;
    margin:0 16px;
    position: relative;
    cursor: pointer;
    }
    .tabs-tt-bar ul .tabs-tt.active,
    .tabs-tt-bar ul .tabs-tt:hover{
    color: #f49d40;
    }
    .tabs-tt-bar ul .tabs-tt.active:before,
    .tabs-tt-bar ul .tabs-tt:hover:before{
    position: absolute;
    bottom: -1px;
    width: 97%;
    height: 2px;
    content: "\20";
    background-color: #f49d40;
    }
    .order_list{
    padding: 20px 20px 20px 20px;
    }
    .order_list table{
    width: 100%;
    border: 1px solid #dfdfdf;
    border-collapse:collapse;
    }
    .order_list table thead tr th{
    padding: 10px 0;
    border-bottom: 1px solid #dfdfdf;
    background: #3D414B;
    color: #D7D7D7;
    font-weight: normal;
    }
    .order_list table tbody tr:nth-child(2n-1){background: #fff;}
    .order_list table tbody tr:nth-child(2n){background: #f7f7f7;}
    .order_list table tbody tr td{
    padding: 10px 0;
    text-align: center;
    }
    .order_list .td-w{
        width: 50px;
    }
    .order_list table tbody tr td:nth-child(2){
        max-width: 110px;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .order_list table tbody tr td:last-child a{
        /*padding-left: 20px;*/
        width: 42%;
        display: inline-block;
        
    }
</style>